// extracted by mini-css-extract-plugin
export default {"root":"GeneralSuggestion_root__n+yrf","name":"GeneralSuggestion_name__WeOeb"};